/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaOutboundImage } from './KoreaOutboundImage';
import {
    KoreaOutboundImageFromJSON,
    KoreaOutboundImageFromJSONTyped,
    KoreaOutboundImageToJSON,
    KoreaOutboundImageToJSONTyped,
} from './KoreaOutboundImage';

/**
 * 
 * @export
 * @interface KoreaOutboundPicVo
 */
export interface KoreaOutboundPicVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof KoreaOutboundPicVo
     */
    orderId?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    orderCode?: string;
    /**
     * 用户名称
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    userName?: string;
    /**
     * 接收人名称
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    receiverName?: string;
    /**
     * 出库运单号
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    trackingNumber?: string;
    /**
     * coupang仓库名称
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    coupangWarehouseName?: string;
    /**
     * 货位
     * @type {Array<string>}
     * @memberof KoreaOutboundPicVo
     */
    locations?: Array<string>;
    /**
     * 总箱数
     * @type {number}
     * @memberof KoreaOutboundPicVo
     */
    boxTotalCount?: number;
    /**
     * coupang预约码
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    coupangInboundCode?: string;
    /**
     * 本地运输方式
     * @type {string}
     * @memberof KoreaOutboundPicVo
     */
    krLocalTransportMethodName?: string;
    /**
     * 总重量
     * @type {number}
     * @memberof KoreaOutboundPicVo
     */
    totalWeight?: number;
    /**
     * 出库图片URL列表
     * @type {Array<KoreaOutboundImage>}
     * @memberof KoreaOutboundPicVo
     */
    imgUrls?: Array<KoreaOutboundImage>;
}

/**
 * Check if a given object implements the KoreaOutboundPicVo interface.
 */
export function instanceOfKoreaOutboundPicVo(value: object): value is KoreaOutboundPicVo {
    return true;
}

export function KoreaOutboundPicVoFromJSON(json: any): KoreaOutboundPicVo {
    return KoreaOutboundPicVoFromJSONTyped(json, false);
}

export function KoreaOutboundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaOutboundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'coupangWarehouseName': json['coupangWarehouseName'] == null ? undefined : json['coupangWarehouseName'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'boxTotalCount': json['boxTotalCount'] == null ? undefined : json['boxTotalCount'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'krLocalTransportMethodName': json['krLocalTransportMethodName'] == null ? undefined : json['krLocalTransportMethodName'],
        'totalWeight': json['totalWeight'] == null ? undefined : json['totalWeight'],
        'imgUrls': json['imgUrls'] == null ? undefined : ((json['imgUrls'] as Array<any>).map(KoreaOutboundImageFromJSON)),
    };
}

export function KoreaOutboundPicVoToJSON(json: any): KoreaOutboundPicVo {
    return KoreaOutboundPicVoToJSONTyped(json, false);
}

export function KoreaOutboundPicVoToJSONTyped(value?: KoreaOutboundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'userName': value['userName'],
        'receiverName': value['receiverName'],
        'trackingNumber': value['trackingNumber'],
        'coupangWarehouseName': value['coupangWarehouseName'],
        'locations': value['locations'],
        'boxTotalCount': value['boxTotalCount'],
        'coupangInboundCode': value['coupangInboundCode'],
        'krLocalTransportMethodName': value['krLocalTransportMethodName'],
        'totalWeight': value['totalWeight'],
        'imgUrls': value['imgUrls'] == null ? undefined : ((value['imgUrls'] as Array<any>).map(KoreaOutboundImageToJSON)),
    };
}

